import { ArrowLeft, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { LoginHint, CustomerFields, TermsCheckbox } from "@/components/booking/DetailsFields";

export const DetailsForm = ({
  details, setDetails, pickupDate, setPickupDate, acceptTerms, setAcceptTerms,
  onSubmit, onBack, paying, payDisabled, total, user,
}) => {
  const field = (key) => (e) => setDetails({ ...details, [key]: e.target.value });

  return (
    <form id="booking-details-form" onSubmit={onSubmit} className="bg-white border border-slate-200 rounded-2xl p-5 sm:p-8 space-y-5" data-testid="booking-details-form">
      {!user && <LoginHint />}
      <CustomerFields details={details} field={field} pickupDate={pickupDate} setPickupDate={setPickupDate} />
      <div className="space-y-2">
        <Label htmlFor="b-address">Dirección de recogida</Label>
        <Input id="b-address" data-testid="booking-address-input" required minLength={5}
          placeholder="Calle, número, piso, ciudad" value={details.address} onChange={field("address")} />
        <p className="text-xs text-slate-500">Con la dirección calculamos los kilómetros desde el local y el coste de gasolina.</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="b-notes">Notas (opcional)</Label>
        <Textarea id="b-notes" data-testid="booking-notes-input" rows={3}
          placeholder="Instrucciones especiales, prendas delicadas..." value={details.notes} onChange={field("notes")} />
      </div>
      <TermsCheckbox checked={acceptTerms} onChange={setAcceptTerms} />
      <div className="flex flex-wrap gap-4 pt-2">
        <Button type="button" variant="outline" className="rounded-full px-6 h-11" data-testid="booking-back-btn" onClick={onBack}>
          <ArrowLeft className="h-4 w-4 mr-2" /> Volver
        </Button>
        <Button type="submit" disabled={paying || payDisabled} data-testid="booking-pay-btn"
          className="hidden lg:inline-flex bg-cyan-500 hover:bg-cyan-600 rounded-full px-8 h-11">
          <CreditCard className="h-4 w-4 mr-2" />
          {paying ? "Redirigiendo..." : `Pagar ${total.toFixed(2)} € con tarjeta`}
        </Button>
      </div>
    </form>
  );
};
